<template>
    <div v-if="!error">
        <v-card
            class="mt-3 legal-docs-card"
            :class="{'mr-4': $vuetify.breakpoint.mdAndUp}"
            v-show="items.length > 0"
            v-for="(item, i) in items.filter(o => isFiltered(o))"
            :key="i"
            :style="{
                borderLeft:
                    `3px solid ${legalDocumentColor(item.legalDocument.status)}`
            }"
        >
            <v-card-title primary-title>
                <v-layout align-start>
                    <div
                        :style="{ color: themeColor }"
                        class="legal-docs-card__title"
                    >
                        <span>{{ params[item.legalDocument.type].shortName }}</span>
                    </div>
                    <div
                        :style="legalDocumentStyle(item.legalDocument.status)"
                        class="legal-docs-card__status"
                    >
                        <i :class="`bexsicon-${legalDocumentIcons(item.legalDocument.status)} tag-status-icon-${item.legalDocument.status}`" />  {{ statusParams[item.legalDocument.status]  }}
                    </div>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <div class="legal-docs-card__description">
                    {{ params[item.legalDocument.type].description }}
                </div>
                <div class="legal-docs-card__responsible-body">
                    <span class="legal-docs-card__responsible-body__label">
                        {{ $t('pages.documents.responsibleBody') }}:
                    </span>
                    <span class="legal-docs-card__responsible-body__value">
                        {{ params[item.legalDocument.type].responsibleBody }}
                    </span>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    v-if="item.attachment && item.legalDocument.status == 1"
                    :style="{ color: themeColor }"
                    @click="$emit('previewFile', item)"
                >
                    <i class="bexsicon-docs-sm" />
                    {{ $t('pages.documents.showDocumentBtn') }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <div
            v-show="items.length === 0"
            class="empty-state"
        >
            {{ emptyState }}
        </div>
    </div>
</template>

<script>
export default {
  name: 'legal-doc-list',
  props: {
    items: {
      type: Array,
      required: true
    },
    params: {
      type: Object,
      required: true
    },
    emptyState: {
      type: String,
      required: true
    },
    themeColor: {
      type: String,
      required: true
    },
    statusParams: {
      type: Object,
      required: true
    },
    visualizedFilter: {
      type: Number,
      default: null
    },
    error: {
      type: Boolean
    }
  },
  methods: {
    isFiltered(item) {
      if (this.visualizedFilter == null) {
        return true;
      } else {
        return item.legalDocument.status === this.visualizedFilter;
      }
    },
    legalDocumentColor(status) {
      switch (status) {
        case 1:
          return '#33cc1e';
        case 2:
          return '#0093f0';
        case 3:
          return 'gray';
      }
    },
    legalDocumentIcons(status) {
      switch (status) {
        case 1:
          return 'msg-sent';
        case 2:
          return 'options';
        case 3:
          return 'close';
      }
    },
    legalDocumentStyle(status) {
      switch (status) {
        case 1:
          return {
            backgroundColor: '#33cc1e',
            color: '#fff'
          };
        case 2:
          return {
            color: '#0093f0'
          };
        case 3:
          return {};
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
>>> .v-card__text {
  padding-top: 0;
  padding-bottom: 0;
}
.legal-docs-card {
  &__title {
    font-size: 21px;
    width: 72%;
    flex-shrink: 2;
    @include breakpoint(mobile) {
      font-size: 1.2em;
    }
  }

  &__status {
    width: 130px;
    font-size: 0.9em;
    margin-left: auto;
    text-align: center;
    right: 1em;
    background-color: #f5f5f5;
    color: var(--light-dark-color);
    padding: 0.24em 0.13em;
    border-radius: 25px;

    i {
      padding: 0 0.1em;
      font-size: 0.8em;
    }

    .tag-status-icon {
      &-2 {
        &:before {
          color: #0093f0;
        }
      }
    }
  }

  &__subtitle {
    font-size: 0.85em;
    margin-top: -5%;
  }

  &__responsible-body {
    margin-top: 2.5%;
    font-size: 1em;
    &__label {
      font-weight: var(--font-weight);
    }

    &__value {
      padding: 0 0.5em;
      font-weight: 400;
    }
  }

  &__description {
    font-size: 1em;
  }

  &:last-of-type {
    margin-bottom: 30px;
  }
}
.tooltip-content {
  color: #b0b0b0;
}
</style>



// WEBPACK FOOTER //
// ./src/components/document/LegalDocList.vue